import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { sortDDLByLabel, useNavigateToLogout } from "../../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DDLDataTable } from "../../DDLDataTable";
import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { IScreens } from "../../../models";
import { MenuHeadsService } from "../../../services/RoleManagementServices/MenuHeadsService";
import { ScreenInfoSetupFieldsPanel } from "./Panels/ScreenInfoSetupFieldsPanel";
import { ScreenService } from "../../../services/RoleManagementServices/ScreenService";
import { ScreenSetupSetupValidationSchema } from "./validator";
import { ScreenSetupToolbar } from "./ScreenSetupToolbar";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";




export interface IScreenSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "screen-single-data-record";
const SCREEN_LIST_DATA_QUERY_KEY = "screen-list";

const useGetData = (
	clientId: string,
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, clientId, id, navigateToLogout],
		queryFn: () => {
			return ScreenService.getById(clientId, id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useScreens = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SCREEN_LIST_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return ScreenService.getScreens(
				clientId,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
const useGetParentLabelsDDL = () =>
	useQuery({
		queryKey: ["parent-Labels-DDL"],
		queryFn: (data) => {
			return MenuHeadsService.getParentLabelsDDL();
		},
		refetchOnWindowFocus: false,
	});
export const ScreenSetup: React.FC<IScreenSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [screensId, setScreensId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useScreens(
		clientId,
		queryParams,
		navigateToLogout
	);

	const screensList: any | null = data;

	const { isPending: isPendingParentLabelsDDL, data: parentLabelsDDL } =
		useGetParentLabelsDDL();

	const { isPending: isSubmitting, mutate: submitScreensFormFields } =
		useMutation({
			mutationFn: ScreenService.create,
			onSuccess: (res: IScreens | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIScreensResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/role-management/screen/${res.data.id}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [SCREEN_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: ["parent-Labels-DDL"],
						}),
					]);
				} else if (res.status === 201) {
					// if (instanceOfIScreensResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/role-management/screen/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [SCREEN_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: ["parent-Labels-DDL"],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		clientId,
		editRecordId,
		navigateToLogout
	);

	const upadtedScreensListItems = useMemo(() => {
		return (
			screensList &&
			screensList.items &&
			screensList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/role-management/screen/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.name}
					</Link>
				),
			}))
		);
	}, [screensList]);


	const DEFAULT_VALUES = {
		name: undefined,
		url: undefined,
		menuOrder: undefined,
		menuParentId: undefined,
		accountType: 200,

	};

	const formMethods = useForm<any>({
		resolver: yupResolver(ScreenSetupSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const onSubmit = (values: any) => {
		const selectedMenuParent = parentLabelsDDL
			.map((x: any) =>
				x.options?.find((y: any) => y.value === values.menuParentId) ||
				(x.value === values.menuParentId ? x : null)
			)
			.find(Boolean);

		let payload = {
			clientId: clientId,
			id: id && id,
			navigateToLogout: navigateToLogout,
			name: values.name,
			url: values.url,
			menuOrder: values.menuOrder,
			menuParentId: values.menuParentId && values.menuParentId,
			menuParentName: selectedMenuParent && selectedMenuParent.label,
			// isAdmin: values.isAdmin,
			accountType: values.accountType,
		};
		submitScreensFormFields(payload);
	};

	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteScreensById } = useMutation({
		mutationFn: ScreenService.delScreens,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Screens fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/role-management/screen`;
			navigate(path);
			return Promise.all([
				queryClient.invalidateQueries({
					queryKey: [SCREEN_LIST_DATA_QUERY_KEY],
				}),
				queryClient.invalidateQueries({
					queryKey: ["parent-Labels-DDL"],
				}),
			]);
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteScreensField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				screensId: screensId,
				navigateToLogout: navigateToLogout,
			};
			deleteScreensById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setScreensId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setScreensId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveScreensById } = useMutation({
		mutationFn: ScreenService.archiveScreens,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Screens fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/role-management/screen`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [SCREEN_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveScreensField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				screensId: screensId,
				navigateToLogout: navigateToLogout,
			};
			archiveScreensById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setScreensId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/role-management/screen`;
		navigate(path);
	};

	const expandedLabels = ["Role Management"];
	const expandedMenuHeadsSetupItem = "Screen Setup"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Screen Setup" &&
				item.label === expandedMenuHeadsSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedMenuHeadsSetupItem && "/role-management/screen",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		screensName: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: IScreens | any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/role-management/screen/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid
		// sx={{
		// 	pb: "5rem",
		// 	"& .MuiAppBar-root": {
		// 		zIndex: 2,
		// 		top: subMenuVisibility ? "154px" : "112px",
		// 	},
		// }}
		>
			<BackdropCircularProgress
				open={isSubmitting || isPendingById || isDeleting || isArchive || isPendingParentLabelsDDL}
				testId="screen Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteScreensField}
				cancelActionHandler={onCloseHandler}
				testId="screen-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="Screen Setup"
										testId={`screen -setup`}
										// leftSpacing={1}
										// rightSpacing={1}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<ScreenInfoSetupFieldsPanel parentLabelsDDL={parentLabelsDDL && sortDDLByLabel(parentLabelsDDL)} formMethods={formMethods} />
									</StandardPanel>
								}
								toolbar={
									<ScreenSetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								showFullDiaplay={true}
								toolbarPosition="bottom"
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 3, lg: 3, xl: 3 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									screensList && upadtedScreensListItems
										? upadtedScreensListItems
										: []
								}
								columns={[
									{ field: "label", headerName: "Name" },
									{ field: "url", headerName: "URL" },
									{ field: "menuParentName", headerName: "Menu Head" },
									{ field: "menuOrder", headerName: "Sequence" },
									{ field: "accountType", headerName: "Account Type" },
								]}
								showHeaderColumns={true}
								showArchiveIcon={false}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								// onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={
									screensList && screensList.total
										? screensList.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"28.8rem"}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveScreensField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"screens-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
